import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { useEffect, useState } from "react";
import {getInstrumentationKey} from "./components/common";
import {getConfig} from "./services/ConfigService";

const browserHistory = createBrowserHistory({ basename: "" });
const reactPlugin = new ReactPlugin();

let InstrumentationKey:any;
let appInsights:any;

var promise = new Promise((resolve) => {
  return getConfig().then((config:any) => {
    InstrumentationKey=config.InstrumentationKey;
    resolve( InstrumentationKey);
    });
});

promise.then( result => {
   InstrumentationKey= result;
   appInsights = new ApplicationInsights({
    config: {
      instrumentationKey:InstrumentationKey?InstrumentationKey.toString():"",
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
      },
    },
  });
  appInsights.loadAppInsights();
});

export { reactPlugin, appInsights };
